module.exports = __webpack_public_path__ + "static/media/park-box3.2d80a4f3.png";